export const ArrowLeftIcon = () => {
  return (
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.5 8L8.13251 15.5L9.5 14.1562L3.20318 8L9.4682 1.84375L8.10071 0.5L0.5 8Z" />
    </svg>
  );
};
